import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

import { backgroundColor, borderImage } from './borders';

class Content extends Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    scrollY: PropTypes.bool,
    borders: PropTypes.arrayOf(
      PropTypes.oneOf(['up', 'up-in', 'down', 'down-out', 'right', 'right-out', 'left', 'left-in']),
    ),
  };

  static defaultProps = {
    className: '',
    borders: [],
    color: '#fff',
    backgroundColor,
    scrollY: false,
  };

  render() {
    const { className, children, borders, backgroundColor, color, scrollY, ...props } = this.props;

    let innerClassName = 'inner optimize';

    const enabledBorders = borders.reduce((obj, border) => {
      obj[border] = true;
      innerClassName += ` ${border}`;
      return obj;
    }, {});

    return (
      <div className={`content ${className}`} {...props}>
        <div
          className={innerClassName}
          style={{
            backgroundColor,
            color,
            overflowY: scrollY ? 'auto' : 'hide',
          }}
        >
          {children}
        </div>

        {enabledBorders['down-out'] && (
          <div
            className="content-border down-out"
            height="20"
            width="100%"
            style={{
              backgroundImage: borderImage('down-out', backgroundColor),
            }}
          />
        )}

        {enabledBorders['up-in'] && (
          <div
            className="content-border up-in"
            height="20"
            width="100%"
            style={{
              backgroundImage: borderImage('up-in', backgroundColor),
            }}
          />
        )}

        {enabledBorders['right-out'] && (
          <div
            className="content-border right-out"
            height="100%"
            width="20"
            style={{
              backgroundImage: borderImage('right-out', backgroundColor),
            }}
          />
        )}

        {enabledBorders['left-in'] && (
          <div
            className="content-border left-in"
            height="100%"
            width="20"
            style={{
              backgroundImage: borderImage('left-in', backgroundColor),
            }}
          />
        )}
      </div>
    );
  }
}

export default Content;
